import styled from "styled-components";

export const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 14px;
  padding-right: 18px;
  width: fit-content;

  ${({ theme }) => theme.media.onlyMobile`
    flex-direction: row-reverse;
    padding-bottom: 8px;
    width: 100%;
  `}

  > img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-left: 13px;
    flex-shrink: 0;
    flex-grow: 1;

    ${({ theme }) => theme.media.onlyMobile`
      margin-left: 0;
      margin-right: 13px;
    `}
  }

  > div {
    text-align: right;

    ${({ theme }) => theme.media.onlyMobile`
      text-align: left;
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      > div {
        margin: 0 !important;
      }
    `}

    > div:first-child {
      margin-bottom: 6px;
      color: ${({ theme }) => theme.colors.neutralsText};
      ${({ theme }) => theme.fontStyles.InterfaceCopy}
    }

    > div:last-child {
      margin-top: 6px;
      color: ${({ theme }) => theme.colors.neutralsTextLight};
      ${({ theme }) => theme.fontStyles.InterfaceCopySmall}
    }
  }
`;
